import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className="mb-4 text-sm text-foreground-500" aria-label="面包屑导航">
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((item, idx) => (
          <li key={`${item.label}-${idx}`} className="flex items-center gap-1">
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-primary-500">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-300">{item.label}</span>
            )}
            {idx < items.length - 1 && (
              <i className="ri-arrow-right-s-line text-base text-foreground-600" />
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}